// extracted by mini-css-extract-plugin
module.exports = {"button":"InputPasteButton_button__zPv_O","root":"InputPasteButton_root__mXUgr"};